module.exports = __webpack_public_path__ + "static/media/mobile_capy_page_area02_img_cn@2x.fa1bae2e.png";